import { EmployeePage } from './EmployeePage';

export default EmployeePage;
